import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Button.scss';

const BUTTON_COLORS = {
  primary: 'primary',
  secondary: 'secondary',
  red: 'red',
};

const SIZES = {
  small: 'small',
  medium: 'medium',
  big: 'big',
  full: 'full',
};

const Button = ({ color, size, classes, children, ...buttonProps }) => (
  <button
    className={classNames('button', color, size, ...classes)}
    type="button"
    {...buttonProps}
  >
    {children}
  </button>
);

Button.propTypes = {
  color: PropTypes.oneOf(Object.keys(BUTTON_COLORS)),
  size: PropTypes.oneOf(Object.keys(SIZES)),
  classes: PropTypes.array,
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  color: BUTTON_COLORS.primary,
  size: SIZES.medium,
  classes: [],
};

export default Button;
